import { AppThunkAction } from './index'
import { ROOT_REDUCER_ACTION_TYPES } from '../types/rootStoreTypes'

export const resetStoreAction = (): AppThunkAction => {
	return dispatch => {
		dispatch({
			type: ROOT_REDUCER_ACTION_TYPES.ROOT_REDUCER_RESET,
		})
	}
}
